module.exports = "<p>\n  provider-approval works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/provider/provider-approval.component.html
// module id = ./src/app/views/provider/provider-approval.component.html
// module chunks = main